export default __webpack_public_path__ + "static/media/videoTop_deco_bar_d.b39eb22f.png";